/**
 * paths 모듈 진입점.
 *
 * 이 파일은 **server-safe** (React/Next 클라이언트 의존 없음).
 * - middleware (Edge Runtime), server component, client component 모두 안전하게 import.
 * - `getPaths(service)`만 노출하므로 hook 호출 사고 위험 없음.
 *
 * 클라이언트 hook은 별도 파일:
 * - `useGoProfileEdit` / `useGoProfileEditNickname` → `./actions` (`'use client'`)
 */
import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection/server';
import { paths29CM } from './29cm';
import { pathsMusinsa } from './musinsa';
import type { SharedPaths } from './types';

export { paths29CM } from './29cm';
export type { EmptyParams, PathBuilder, PathOptions, Query, QueryValue } from './defineRoute';
export { pathsMusinsa } from './musinsa';
export type { SharedPaths } from './types';

// NOTE: SERVICE.UNKNOWN은 29CM로 fallback (middleware의 기존 fallthrough 동작과 일치)
export const getPaths = (service: ServiceType): SharedPaths =>
  service === SERVICE.MUSINSA ? pathsMusinsa : paths29CM;
